/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('DinghyBookingMember', DinghyBookingMember);

    DinghyBookingMember.$inject = ['$resource', 'DateUtils'];

    function DinghyBookingMember ($resource, DateUtils) {
        var resourceUrl =  'api/member/dinghy-events/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fromDate = DateUtils.convertDateTimeFromServer(data.fromDate);
                        data.untilDate = DateUtils.convertDateTimeFromServer(data.untilDate);
                    }
                    return data;
                }
            }
        });
    }
})();
